
	import ButtonCustom from '@/components/shared/buttons/ButtonCustom.vue';
	import { useButtonCustom } from '@/core/hooks/use-button-custom';
	import { useDateTime } from '@/core/hooks/use-date-time-hook';
	import { IDinhMucCoDinhNewResponseBase } from '@/core/interfaces/ApiResponses';
	import PageContentSection from '@/layout/_shared/PageContentSection.vue';
	import moment from 'moment/moment';
	import { defineComponent, PropType, ref } from 'vue';
	import { useRouter } from 'vue-router';
	import VatTuDinhMucTable from './vat-tu-dinh-muc-table/VatTuDinhMucTable.vue';

	type DinhMucStatus = 'expired' | 'invalid' | 'valid';

	export default defineComponent({
		name: 'dinh-muc-co-dinh-toa-xe-section',

		components: {
			PageContentSection,
			ButtonCustom,
			VatTuDinhMucTable,
		},

		emits: ['added'],

		setup() {
			const { ButtonsType, ButtonTypeColors } = useButtonCustom();
			const { formatDisplayingDate } = useDateTime();

			const vatTuDinhMucTableRef = ref();

			const { push } = useRouter();

			return {
				ButtonsType,
				ButtonTypeColors,
				formatDisplayingDate,
				vatTuDinhMucTableRef,
				push,
			};
		},

		props: {
			danhMucToaXeId: {
				type: Number,
				required: true,
			},
			dinhMucCoDinhItems: {
				type: Array as PropType<Array<IDinhMucCoDinhNewResponseBase>>,
				default: () => [],
			},
		},

		data() {
			return {
				isModalOpen: false,
				selectingDinhMuc: null as IDinhMucCoDinhNewResponseBase | null,
			};
		},

		computed: {
			dinhMucTotalDisplay() {
				if (!this.dinhMucCoDinhItems)
					return `Định mức cố định (chưa có vật tư)`;
				return `Định mức cố định (Số lượng: ${this.dinhMucCoDinhItems.length})`;
			},
		},

		methods: {
			getDinhMucStatus(
				row: IDinhMucCoDinhNewResponseBase,
			): DinhMucStatus {
				const status = (row as { status?: DinhMucStatus }).status;
				if (status === 'expired' || status === 'invalid' || status === 'valid') {
					return status;
				}
				const today = moment().startOf('day');
				const ngayBanHanh = row.ngay_ban_hanh
					? moment(row.ngay_ban_hanh).startOf('day')
					: null;
				const ngayHetHan = row.ngay_het_han
					? moment(row.ngay_het_han).startOf('day')
					: null;
				if (ngayHetHan && today.isAfter(ngayHetHan)) return 'expired';
				if (ngayBanHanh && today.isBefore(ngayBanHanh)) return 'invalid';
				return 'valid';
			},

			statusLabel(status: DinhMucStatus): string {
				const labels: Record<DinhMucStatus, string> = {
					expired: 'Hết hạn',
					invalid: 'Chưa khả dụng',
					valid: 'Khả dụng',
				};
				return labels[status] ?? status;
			},

			statusBadgeClass(status: DinhMucStatus): string {
				const classes: Record<DinhMucStatus, string> = {
					expired: 'el-tag--danger',
					invalid: 'el-tag--warning',
					valid: 'el-tag--success',
				};
				return classes[status] ?? '';
			},

			ngayHetHanBadgeClass(row: IDinhMucCoDinhNewResponseBase): string {
				if (!row.ngay_het_han) return 'el-tag--success';
				return moment().isAfter(moment(row.ngay_het_han).startOf('day'))
					? 'el-tag--danger'
					: 'el-tag--success';
			},

			onDetailButtonClicked(index) {
				this.selectingDinhMuc = this.dinhMucCoDinhItems[index];

				if (this.vatTuDinhMucTableRef) {
					this.vatTuDinhMucTableRef.isDialogDisplay = true;
				}
			},

			onCloseModal() {
				this.selectingDinhMuc = null;

				if (this.vatTuDinhMucTableRef) {
					this.vatTuDinhMucTableRef.isDialogDisplay = false;
				}
			},
		},
	});
